var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import authentication from "@irati/auth";
import UsersForBusiness, { userList, getNextPage } from "@irati/identity/apollo/query/UsersForBusiness";
import ShowMore from "./ShowMore";
import AlphabetSearch from "../AlphabetSearch/AlphabetSearch";
import SearchAndSort from "../SearchAndSort";
import NoUsers from "../NoUsers/NoUsers";
import { A_Z } from "../../constants/sort";
import { FILTER_OPTIONS_NO_DEACTIVATED } from "../../constants/filter";
export var INITIAL_USERLIST_VARIABLES = function (teamId) { return ({
    includeBusiness: false,
    enabled: true,
    limit: 10,
    offset: 0,
    businessId: authentication.userTenant().uuid,
    teamId: teamId,
    sort: A_Z
}); };
var UsersList = /** @class */ (function (_super) {
    __extends(UsersList, _super);
    function UsersList(props) {
        var _this = _super.call(this, props) || this;
        /** @description: Fallback function until `<UsersForBusiness />` Query component mounts */
        _this.refetch = function () { };
        _this.setVariables = function (variables) { return _this.setState({ variables: variables }); };
        _this.handleSearch = function (searchString) {
            _this.setVariables(__assign(__assign({}, _this.state.variables), { searchString: searchString }));
        };
        _this.handleFilter = function (filter) {
            var variables = __assign(__assign({}, INITIAL_USERLIST_VARIABLES(_this.props.teamId)), filter);
            _this.setVariables(variables);
        };
        _this.handleSort = function (sort) {
            _this.setVariables(__assign(__assign({}, _this.state.variables), { sort: sort, offset: 0 }));
        };
        _this.handleAlphabet = function (lastNameCharacter) {
            var variables = __assign(__assign({}, INITIAL_USERLIST_VARIABLES(_this.props.teamId)), { lastNameCharacter: lastNameCharacter });
            _this.setVariables(variables);
        };
        _this.state = {
            variables: INITIAL_USERLIST_VARIABLES(_this.props.teamId)
        };
        return _this;
    }
    UsersList.prototype.componentDidMount = function () {
        if (this.props.refetchOnMount) {
            this.refetch();
        }
    };
    UsersList.prototype.render = function () {
        var _this = this;
        var variables = this.state.variables;
        var _a = this.props, children = _a.children, filterOptions = _a.filterOptions;
        var errorMessage = variables.searchString || variables.lastNameCharacter
            ? "admin.containers.teamUserList.noUsers.emptySearch"
            : "admin.containers.teamUserList.noUsers.message";
        return (React.createElement(React.Fragment, null,
            React.createElement(SearchAndSort, { filterOptions: filterOptions, variables: variables, onSearch: this.handleSearch, onFilter: this.handleFilter, onSort: this.handleSort }),
            React.createElement(AlphabetSearch, { onSearch: this.handleAlphabet, variables: variables }),
            React.createElement(UsersForBusiness, { variables: variables }, function (apollo) {
                _this.refetch = apollo.refetch;
                var users = userList(apollo);
                if (users.results.length === 0) {
                    return React.createElement(NoUsers, { message: errorMessage });
                }
                return (React.createElement(React.Fragment, null,
                    children({ variables: variables, users: users }),
                    React.createElement(ShowMore, { onNewPage: function (isVisible) { return isVisible && getNextPage(apollo, variables); } })));
            })));
    };
    UsersList.defaultProps = {
        filterOptions: FILTER_OPTIONS_NO_DEACTIVATED,
        refetchOnMount: true
    };
    return UsersList;
}(PureComponent));
export default UsersList;
